//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    swatch: {
      type: Array,
      required: true
    },

    swatchIcon: {
      type: String,
      default: ''
    },

    isLarge: {
      type: Boolean,
      default: false
    },

    isActive: {
      type: Boolean,
      default: false
    },

    isIris: {
      type: Boolean,
      default: false
    },

    isRecycled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes () {
      return {
        BaseSwatch: true,
        'is-large': this.isLarge,
        'is-active': this.isActive
      }
    }
  }
}
